// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KXqp28R4rSMgdpHT{display:flex;flex-direction:column;gap:32px}.lZEpw3szCwifni1r{margin:0}.YClryvIPQpAmAoeT{display:flex;flex-direction:column}.cEGpfRo3Kohj8jQj{display:flex;justify-content:center}.L8S6zR6r8T44Uwyo{display:flex;flex-direction:column;align-items:flex-start;justify-content:center;width:max-content;max-width:100%;flex-wrap:wrap}.K4Ex8XhsEijQwfJH{display:flex;align-items:center;gap:4px;padding-top:4px;padding-bottom:4px}.tR5thgd2h4ssLdrY{display:flex;gap:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContent": `KXqp28R4rSMgdpHT`,
	"adminTitle": `lZEpw3szCwifni1r`,
	"tableContent": `YClryvIPQpAmAoeT`,
	"modalContentContainer": `cEGpfRo3Kohj8jQj`,
	"logDetailsContainer": `L8S6zR6r8T44Uwyo`,
	"logItem": `K4Ex8XhsEijQwfJH`,
	"logMessage": `tR5thgd2h4ssLdrY`
};
export default ___CSS_LOADER_EXPORT___;
